export default "__VITE_ASSET__f87a191b__"